export default __webpack_public_path__ + "static/media/lakshmi sharma.d80440fe.jpg";